import { render, staticRenderFns } from "./Coupons.vue?vue&type=template&id=50a68cce&"
import script from "./Coupons.vue?vue&type=script&lang=js&"
export * from "./Coupons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/eric/projects/musical/musical-admin-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50a68cce')) {
      api.createRecord('50a68cce', component.options)
    } else {
      api.reload('50a68cce', component.options)
    }
    module.hot.accept("./Coupons.vue?vue&type=template&id=50a68cce&", function () {
      api.rerender('50a68cce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Coupons.vue"
export default component.exports